import Colcade from 'colcade';

class InspirationGrid {
  constructor(element) {
    this._element = element;

    this._cacheSelectors();
    this._init();
  }

  _cacheSelectors() {
    this._grid = this._element;
  }

  _init() {
    this.colc = new Colcade(this._grid, {
      columns: '.grid-col',
      items: '.grid-item',
    });
  }
}

export default InspirationGrid;
